import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Col,
  Row,
  Card,
  Divider,
  InputNumber,
  Switch,
  Space,
} from 'antd';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { updateShift } from '../shifts/api';
import { getDateFromTimestamp } from '../utils';

function RequestModal({ shift, visible, onClose, onConfirm }) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const { formatMessage } = useIntl();

  const {
    startDate,
    placeName,
    address,
    placeSport,
    totalPlayers,
    localTeam,
    visitTeam,
  } = shift;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = async values => {
    onConfirm();
    onClose();
  };
  const onFinishFailed = values => { };

  return (
    <Modal
      title={formatMessage({ id: 'shifts.actions.play' })}
      open={visible}
      onOk={form.submit}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        labelCol={{
          xs: { span: 5 },
        }}
        wrapperCol={{
          xs: { span: 12 },
        }}
        initialValues={{
          remember: false,
          size: 'small',
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
        Recuerda ser puntual, se recomienda llegar 15 minutos antes al partido.
        El partido no comienza hasta que todos paguen.
      </Form>
    </Modal>
  );
}

export default RequestModal;
